import { autocomplete, autocompletePreview, autocompleteItem, clearContainer, iconContainer, iconContainerDisabled, inputContainer, readOnly, } from '../styles/legacy';
import { autocomplete as autocompleteCitron, autocompleteItem as autocompleteItemCitron, autocompletePreview as autocompletePreviewCitron, clearContainer as clearContainerCitron, clearContainerFocus, inputContainer as inputContainerCitron, iconContainer as iconContainerCitron, iconContainerDisabled as iconContainerDisabledCitron, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
export var ReadOnly = citrusStyled.p('readOnly', readOnly);
export var InputContainer = citrusStyled.div('inputContainer', {
    legacy: inputContainer,
    citrus2022: inputContainerCitron,
});
export var AutoComplete = citrusStyled.ul('autocomplete', {
    legacy: autocomplete,
    citrus2022: autocompleteCitron,
});
export var AutoCompleteItem = citrusStyled.li('autocompleteItem', {
    legacy: autocompleteItem,
    citrus2022: autocompleteItemCitron,
});
export var AutoCompletePreview = citrusStyled.div('autocompletePreview', {
    legacy: autocompletePreview,
    citrus2022: autocompletePreviewCitron,
});
export var IconContainer = citrusStyled.div('iconContainer', {
    legacy: iconContainer,
    citrus2022: iconContainerCitron,
});
export var IconContainerDisabled = citrusStyled.div('iconContainerDisabled', {
    legacy: iconContainerDisabled,
    citrus2022: iconContainerDisabledCitron,
});
export var ClearContainer = citrusStyled.div('clearContainer', {
    legacy: clearContainer,
    citrus2022: clearContainerCitron,
});
export var ClearContainerFocus = citrusStyled.div('clearContainerFocus', clearContainerFocus);
export var Styled = {
    AutoComplete: AutoComplete,
    AutoCompleteItem: AutoCompleteItem,
    AutoCompletePreview: AutoCompletePreview,
    ClearContainer: ClearContainer,
    ClearContainerFocus: ClearContainerFocus,
    IconContainer: IconContainer,
    IconContainerDisabled: IconContainerDisabled,
    InputContainer: InputContainer,
    ReadOnly: ReadOnly,
};
